// AccordionData.js (Static lookup file)
import { FormFields } from '../Forms/FormJson'; // Form fields to be used

export const items = [
  {
    id: 1,
    label: 'The Pitch',
    type: 'text',  // Type of content to render
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    subItems: [
      {
        id: 11,
        label: 'Basics',
        type: 'form',  // A form type content
        formFields: FormFields.companyBasic, // Reference to form fields
        buttonText: 'Save Company Info',
      },
      {
        id: 12,
        label: 'Returns',
        type: 'form',  // A form type content
        //formFields: FormFields.companyBasic, // Reference to form fields
        buttonText: 'Save Company Info',
      },
      {
        id: 13,
        label: 'Team',
        type: 'form',  // A form type content
        //formFields: FormFields.companyBasic, // Reference to form fields
        buttonText: 'Save Company Info',
      },
      {
        id: 14,
        label: 'Project',
        type: 'form',  // A form type content
        //formFields: FormFields.companyBasic, // Reference to form fields
        buttonText: 'Save Company Info',
      },
      {
        id: 15,
        label: 'Investment Status',
        type: 'form',  // A form type content
        //formFields: FormFields.companyBasic, // Reference to form fields
        buttonText: 'Save Company Info',
      },
    ],
  },
  {
    id: 2,
    label: 'The Terms',
    type: 'text',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    subItems: [
      {
        id: 21,
        label: 'Contract',
        type: 'text',
        content: 'Additional content for Contract.',
      },
      {
        id: 22,
        label: 'Perks',
        type: 'text',
        content: 'Nested content under Perks.',
      },
    ],
  },
  {
    id: 3,
    label: 'The Raise',
    type: 'text',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    subItems: [
      {
        id: 31,
        label: 'Funding Goals',
        type: 'text',
        content: 'Additional content for Funding Goals.',
      },
      {
        id: 32,
        label: 'Important Dates',
        type: 'text',
        content: 'Nested content under Important Dates.',
      },
    ],
  },
];